const commonAndMisc = {
  errorMessage404: "ओह! आप जिस पेज को खोज रहे हैं वह मौजूद नहीं है।", // translated 
  errorContentUnavailable:
    "माफ़ कीजिए! आप जिस सामग्री की तलाश कर रहे हैं वह मौजूद नहीं है। कृपया समस्या के बारे में हमसे संपर्क करें।", // translated 
  backToHome: "घर वापिस जा रहा हूँ", // translated 
  information: "जानकारी", // translated 
  additionalInformation: "अतिरिक्त जानकारी", // translated 
  destinationPlaceholder: "आप कहां जा रहे हैं", // translated 
  aboutUs: "हमारे बारे में", // translated 
  pleaseWait: "कृपया प्रतीक्षा करें...", // translated 
  featuredHotels: "विशेष होटल", // translated 
  topPackages: "शीर्ष पैकेज", // translated 
  topTours: "शीर्ष पर्यटन", // translated 
  traveller: "यात्री", // translated 
  reviews: "समीक्षा", // translated 
  home: "घर", // translated 
  packages: "संकुल", // translated 
  experiences: "अनुभव", // translated 
  close: "बंद करना", // translated 
  loadingMessage: "कृपया प्रतीक्षा करें, हम सर्वोत्तम उपलब्ध कीमतों की खोज कर रहे हैं।", // translated 
  loadingMessageTheHotelCo:
    "कृपया प्रतीक्षा करें, हम सर्वोत्तम उपलब्ध कीमतों की खोज कर रहे हैं।", // translated 
  loadingMessageSearchStrip:
    "कृपया प्रतीक्षा करें, हम उपलब्ध सर्वोत्तम कीमतों की तलाश कर रहे हैं...", // translated 
  topCountriesToVisit: "घूमने के लिए शीर्ष देश", // translated 
  profile: "प्रोफ़ाइल", // translated 
  reservations: "आरक्षण", // translated 
  myBookings: "मेरी बुकिंग", // translated 
  address: "पता", // translated 
  firstName: "पहला नाम", // translated 
  lastName: "उपनाम", // translated 
  email: "ईमेल", // translated 
  login: "लॉग इन करें", // translated 
  logout: "लॉग आउट", // translated 
  myProfile: "मेरी प्रोफाइल", // translated 
  myAccount: "मेरा खाता", // translated 
  myPoints: "मेरे विचार", // translated 
  myQuotations: "मेरे उद्धरण", // translated 
  myChatRooms: "मेरी चैट", // translated 
  chatRoomsListEmpty: "इस खाते के लिए कोई चैट रूम उपलब्ध नहीं है।", // translated 
  chatRoomsOpen: "खुला", // translated 
  chatRoomsLastActivity: "अंतिम गतिविधि", // translated 
  chatRoomsUnread: "अपठित ग", // translated 
  chatRoomsBadgeQuotation: "उद्धरण", // translated 
  chatRoomsBadgeTripOffer: "यात्रा प्रस्ताव", // translated 
  chatRoomsOpenQuotationAria: "कोटेशन चैट खोलें: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "यात्रा संबंधी प्रस्तावों पर चैट करें: {{name}}", // translated 
  chatRoomsOpenGenericAria: "चैट खोलें: {{नाम}}", // translated 
  quotationChatInvalidLink:
    "अमान्य चैट लिंक। कृपया अपनी प्रोफ़ाइल या कोटेशन सूची से चैट खोलें, या रूम_कोड या रूम_यूआईडी में से किसी एक का उपयोग करें।", // translated 
  quotationChatNoTripDetails: "इस चैट के लिए यात्रा संबंधी विवरण उपलब्ध नहीं हैं।", // translated 
  chat: "बात करना", // translated 
  verified: "सत्यापित", // translated 
  unverified: "अपुष्ट", // translated 
  selectLanguage: "भाषा चुने", // translated 
  selectCurrency: "मुद्रा का चयन करें", // translated 
  upgrade: "उन्नत करना", // translated 
  membership: "सदस्यता", // translated 
  travelTrust: "यात्रा ट्रस्ट", // translated 
  signInUp: "लॉग इन/लॉग अप करें", // translated 
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "विश्वभर के होटल और रिसॉर्ट्स बेहतरीन थोक दरों पर उपलब्ध हैं।", // translated 
  dashboard: "डैशबोर्ड", // translated 
  pricing: "मूल्य निर्धारण", // translated 
  refundable: "रिफंडेबल", // translated 
  cars: "कारें", // translated 
  cruises: "परिभ्रमण", // translated 
  view: "देखना", // translated 
  price: "कीमत", // translated 
  totalPrice: "कुल कीमत", // translated 
  filterRoomName: "कमरे के नाम को फ़िल्टर करें", // translated 
  get: "पाना", // translated 
  guestInformationValidation: "अतिथि जानकारी सत्यापन", // translated 
  reservation: "आरक्षण", // translated 
  checkIn: "चेक इन", // translated 
  checkOut: "चेक आउट", // translated 
  paymentInitiattionErroeMessage:
    "हम आपकी भुगतान प्रक्रिया शुरू नहीं कर पाए। असुविधा के लिए हमें खेद है।", // translated 
  warning: "चेतावनी", // translated 
  couldNotFindPriceForDateWarning:
    "हमें इस तारीख के लिए कोई कीमत नहीं मिली। कृपया किसी और तारीख के लिए दोबारा कोशिश करें।", // translated 
  searchFormValidationError: "खोज प्रपत्र सत्यापन त्रुटि", // translated 
  pleaseSelectValidDateFirst: "कृपया पहले एक वैध तिथि चुनें", // translated 
  searchError: "खोज त्रुटि", // translated 
  priceSearchInitiationError:
    "हम मूल्य खोज प्रक्रिया शुरू नहीं कर पाए। कृपया बाद में पुनः प्रयास करें। असुविधा के लिए हमें खेद है।", // translated 
  searchWarning: "खोज चेतावनी", // translated 
  couldNotFindPriceAndOrAvailability:
    "आपकी अनुरोधित वस्तु के लिए हमें कीमत और/या उपलब्धता की जानकारी नहीं मिल पाई। असुविधा के लिए हमें खेद है।", // translated 
  joinNow: " अब शामिल हों", // translated 
  signIn: "दाखिल करना", // translated 
  searchNow: "अब खोजें", // translated 
  bookingFailed: "बुकिंग विफल", // translated 
  sorryForTheInconvenience: "असुविधा के लिए हमें खेद है", // translated 
  contactUsToAssistWithYourBooking:
    "कृपया बुकिंग संबंधी सहायता के लिए हमसे संपर्क करें। असुविधा के लिए हमें खेद है।", // translated 
  paymentFailedTryAgain: "भुगतान विफल रहा। कृपया पुनः प्रयास करें।", // translated 
  quickLinks: "त्वरित सम्पक", // translated 
  tours: "टूर्स", // translated 
  termsAndConditions: "नियम और शर्तें", // translated 
  pleaseWaitWhileInitiatingPayment:
    "कृपया प्रतीक्षा करें, हम आपकी भुगतान प्रक्रिया शुरू कर रहे हैं।", // translated 
  back: "पीछे", // translated 
  nextStep: "अगला कदम", // translated 
  book: "किताब", // translated 
  checkout: "चेक आउट", // translated 
  specifyPickUpPoint: "कृपया अपना पसंदीदा पिकअप स्थान निर्दिष्ट करें।", // translated 
  pickupPoint: "पिक अप बिंदु", // translated 
  optional: "वैकल्पिक", // translated 
  provideImportantInfoForYourTravel:
    "कृपया हमें यात्रा के दौरान आवश्यक किसी भी जानकारी के बारे में बताएं।", // translated 
  remarks: "टिप्पणी", // translated 
  travellerInformation: "यात्री जानकारी", // translated 
  bookingRemarks: "बुकिंग संबंधी टिप्पणियाँ", // translated 
  bookingOverview: "बुकिंग का अवलोकन", // translated 
  paymentFailed: "भुगतान विफल रही", // translated 
  paymentSuccess: "भुगतान सफल", // translated 
  at: "पर", // At date // translated 
  on: "पर", // on date // translated 
  person: "व्यक्ति", // translated 
  cancellationPolicy: "रद्द करने की नीति", // translated 
  From: "से", // translated 
  to: "को", // translated 
  cancellationIs: "रद्दीकरण है", // translated 
  pickup: "उठाना", // translated 
  flights: "टिकट", // translated 
  Accommodation: "आवास", // translated 
  payAndBook: "भुगतान करें और बुकिंग करें", // translated 
  onRequest: "अनुरोध पर", // translated 
  weAreFindingTheBestAvailableServices:
    "हम सर्वोत्तम उपलब्ध सेवाओं की खोज कर रहे हैं।", // translated 
  withTheBestAvailablePrices: "सर्वोत्तम उपलब्ध कीमतों के साथ", // translated 
  inRealTime: "वास्तविक समय में", // translated 
  seconds: "सेकंड", // translated 
  thisProcessCanTakeUpToOneMinute: "इस प्रक्रिया में 1 मिनट तक का समय लग सकता है।", // translated 
  pleaseDoNotRefreshThisPage: "कृपया इस पेज को रीफ़्रेश न करें।", // translated 
  wellItSeemsItCanTakeBitLonger: "खैर... लगता है इसमें थोड़ा और समय लग सकता है।", // translated 
  yourBrowserDoesNotSupportTheVideoTag:
    "आपका ब्राउज़र में वीडियो टैग समर्थित नहीं है", // translated 
  bookingSuccess: "बुकिंग सफल रही", // translated 
  bookingReference: "आरक्षण संदर्भ", // translated 
  referenceCopied: "संदर्भ प्रतिलिपि किया गया", // translated 
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "जल्द ही आपको एक ईमेल प्राप्त होगा जिसमें आपकी बुकिंग के लिए सभी आवश्यक जानकारी होगी।", // translated 
  viewMore: "और देखें", // translated 
  readMore: "और पढ़ें", // translated 
  customerSupport: "ग्राहक सहेयता", // translated 
  socialMedia: "सोशल मीडिया", // translated 
  hours: "घंटे", // translated 
  hour: "घंटा", // translated 
  minutes: "मिनट", // translated 
  minute: "मिनट", // translated 
  memberId: "सदस्य पहचान पत्र", // translated 
  star: "तारा", // translated 
  stars: "सितारे", // translated 
  proceed: "आगे बढ़ना", // translated 
  clearAllFilters: "सभी फ़िल्टर साफ़ करें", // translated 
  clearYourFilters: "परिणाम देखने के लिए कृपया अपने फ़िल्टर विकल्प साफ़ करें।", // translated 
  noOptionsForSelectedFilters: "आपके फ़िल्टरों से मिलान करने के लिए कोई विकल्प उपलब्ध नहीं हैं", // translated 
  privacyPolicy: "गोपनीयता नीति", // translated 
  security: "सुरक्षा", // translated 
  nearby: "आस-पास", // translated 
  distanceFromSelection: "चयन से दूरी", // translated 
  km: "किमी", // translated 
  restaurants: "रेस्टोरेंट", // translated 
  active: "सक्रिय", // translated 
  visitSite: "साइट पर जाएँ", // translated 
  score: "अंक", // translated 
  applicationAvailable: "आवेदन उपलब्ध है", // translated 
  sendUsEmail: "हमें एक ईमेल भेजो", // translated 
  sendUsYourRequest: "हमें अपना अनुरोध भेजें", // translated 
  notAvailable: "उपलब्ध नहीं है", // translated 
  found: "मिला", // translated 
  progressAt: "प्रगति पर", // translated 
  currency: "मुद्रा", // translated 
  sendUsRequest: "हमें अपना अनुरोध भेजें", // translated 
  noReservationsForThisProduct: "इस उत्पाद के लिए कोई आरक्षण नहीं है", // translated 
  noBookingsForThisProduct: "इस उत्पाद के लिए कोई बुकिंग उपलब्ध नहीं है।", // translated 
  noReservationsOfThisProduct: "इस उत्पाद प्रकार के लिए कोई आरक्षण नहीं है", // translated 
  actions: "कार्रवाई", // translated 
  save: "बचाना", // translated 
  confirmed: "की पुष्टि", // translated 
  cancelled: "रद्द कर दिया गया", // translated 
  pending: "लंबित", // translated 
  notConfirmed: "पुष्टि नहीं", // translated 
  status: "स्थिति", // translated 
  reference: "संदर्भ", // translated 
  leadGuest: "मुख्य अतिथि", // translated 
  sendVoucherEmail: "वाउचर ईमेल भेजें", // translated 
  sendCancellationEmail: "रद्दीकरण ईमेल भेजें", // translated 
  downloadVoucher: "वाउचर डाउनलोड करें", // translated 
  emailHasBeenSent: "ईमेल सफलतापूर्वक भेज दिया गया", // translated 
  emailNotSentTryAgain: "ईमेल भेजा नहीं गया! कृपया पुनः प्रयास करें।", // translated 
  titleIsRequired: "शीर्षक आवश्यक है", // translated 
  genderIsRequired: "लिंग की जानकारी आवश्यक है", // translated 
  firstNameMustContainAlphabetic:
    "प्रथम नाम में केवल अक्षर ही होने चाहिए", // translated 
  firstNameIsRequired: "पहला नाम आवश्यक है", // translated 
  lastNameIsRequired: "अंतिम नाम आवश्यक है", // translated 
  lastNameMustContainAlphabetic:
    "अंतिम नाम में केवल अक्षर ही होने चाहिए", // translated 
  phoneNumberInTheFormat: "फ़ोन नंबर बिना स्पेस के निर्धारित प्रारूप में होना चाहिए।", // translated 
  phoneNumberIsRequired: "फ़ोन नंबर आवश्यक है", // translated 
  emailIsRequired: "ईमेल की जरूरत है", // translated 
  invalidEmail: "अमान्य ईमेल", // translated 
  addressIsRequired: "पता आवश्यक है", // translated 
  cityIsRequired: "शहर आवश्यक है", // translated 
  postalCodeIsRequired: "पोस्टल कोड आवश्यक है", // translated 
  countryIsRequired: "देश आवश्यक है", // translated 
  yourReservationIsInProgress: "आपकी बुकिंग प्रक्रियाधीन है।", // translated 
  yourReservationHasBeenRegistered: "आपकी बुकिंग पंजीकृत हो गई है।", // translated 
  clickHere: "यहाँ क्लिक करें", // translated 
  iHaveReadAgreeWithAbove: "मैंने उपरोक्त को पढ़ लिया है और उससे सहमत हूँ।", // translated 
  pleaseCheckTheBox:
    "अगले चरण पर आगे बढ़ने से पहले, कृपया नीचे दिए गए बॉक्स पर टिक करके यह दर्शाएं कि आपने दी गई जानकारी पढ़ ली है और उससे सहमत हैं।", // translated 
  pleaseAcceptProperty:
    "कृपया यह दर्शाने के लिए ऊपर दिए गए बॉक्स पर निशान लगाएं कि जिस संपत्ति को बुक किया जा रहा है वह वही है जिसकी आपको आवश्यकता है।", // translated 
  ourContactNumbersAre: "हमारे संपर्क नंबर ये हैं", // translated 
  operationalHours: "परिचालन घंटे", // translated 
  monday: "सोमवार", // translated 
  tuesday: "मंगलवार", // translated 
  wednesday: "बुधवार", // translated 
  thursday: "गुरुवार", // translated 
  friday: "शुक्रवार", // translated 
  saturday: "शनिवार", // translated 
  sunday: "रविवार", // translated 
  monday_to_friday: "सोमवार से शुक्रवार", // translated 
  closed: "बंद किया हुआ", // translated 
  topUpPoints: "टॉप अप पॉइंट्स", // translated 
  gender: "लिंग", // translated 
  nationality: "राष्ट्रीयता", // translated 
  amountIn: "इसमें राशि", // translated 
  amountOut: "राशि बाहर", // translated 
  maintenanceTitle: "रखरखाव के तहत वेबसाइट", // translated 
  maintenanceDescription:
    "हम निर्धारित रखरखाव कार्य कर रहे हैं। कृपया कुछ देर बाद दोबारा जाँच करें।", // translated 
  maintenanceCountdownLabel: "अनुमानित शेष समय", // translated 
  maintenanceLogoAlt: "वेबसाइट लोगो", // translated 
  maintenanceDays: "दिन", // translated 
  maintenanceHours: "घंटे", // translated 
  maintenanceMinutes: "मिनट", // translated 
  maintenanceSeconds: "सेकंड", // translated 
  maintenanceStatusBadge: "अनुसूचित रखरखाव", // translated 
  maintenanceRefresh: "पेज रीफ़्रेश करें", // translated 
  maintenanceExpired:
    "रखरखाव कार्य शीघ्र ही पूरा हो जाएगा। कृपया पृष्ठ को रीफ़्रेश करें।", // translated 
};


export default commonAndMisc;
